// Library Import
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  GridItem,
  Input,
  SimpleGrid,
  Stack,
  Select,
  useBoolean,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

// Icon Imports

// Local Imports
import {
  getChallenge,
  deleteChallenge,
  updateChallenge,
} from "../../redux/thunks/adminthunk";
import { useDispatch, useSelector } from "react-redux";
import Toasts from "../Toasts";
import { redSetToast } from "../../redux/slices/userSlice";
import {
  redResetChallengeDeleted,
  redResetChallengeDetails,
} from "../../redux/slices/adminSlice";

const Deletetask = () => {
  const dispatch = useDispatch();

  const [challengeName, setChallengeName] = useState("");
  const [challengeDesc, setChallengeDesc] = useState("");
  const [difficultyLev, setDifficultyLev] = useState("");
  const [score, setScore] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timeDur, setTimeDur] = useState("");
  const [challengeId, setChallengeId] = useState("");
  const [language, setLanguage] = useState("");
  const [tags, setTags] = useState("");

  const {
    challengeDetails,
    challengeDetailsLoading,
    error,
    challengeDeleted,
    updatedChallenge,
  } = useSelector((state) => state.stateAdminReducer);

  useEffect(() => {
    if (challengeDetails) {
      setChallengeName(challengeDetails.challengeName);
      setChallengeDesc(challengeDetails.challengeDesc);
      setDifficultyLev(challengeDetails.difficultyLev);
      setScore(challengeDetails.score);
      setStartDate(challengeDetails.startDate);
      setEndDate(challengeDetails.endDate);
      setTimeDur(challengeDetails.timeDur);
      setChallengeId(challengeDetails.challengeId);
      setLanguage(challengeDetails.language);
      setTags(challengeDetails.tags);
    } else if (updatedChallenge) {
      setChallengeName(updatedChallenge.challengeName);
      setChallengeDesc(updatedChallenge.challengeDesc);
      setDifficultyLev(updatedChallenge.difficultyLev);
      setScore(updatedChallenge.score);
      setStartDate(updatedChallenge.startDate);
      setEndDate(updatedChallenge.endDate);
      setTimeDur(updatedChallenge.timeDur);
      setChallengeId(updatedChallenge.challengeId);
      setLanguage(updatedChallenge.language);
      setTags(updatedChallenge.tags);
    } else {
      setChallengeName("");
      setChallengeDesc("");
      setDifficultyLev("");
      setScore("");
      setStartDate("");
      setEndDate("");
      setTimeDur("");
      setChallengeId("");
      setLanguage("");
      setTags("");
    }

    if (error) {
      dispatch(redSetToast({ title: error, status: "error" }));
    }

    if (challengeDeleted) {
      dispatch(
        redSetToast({
          title: "Challenged deleted succesfully",
          status: "success",
        })
      );

      dispatch(redResetChallengeDeleted());
    }
  }, [challengeDetails, error, challengeDeleted, updatedChallenge]);

  const handleUpdateChallenge = () => {
    if (
      challengeName &&
      challengeDesc &&
      difficultyLev &&
      score &&
      startDate &&
      endDate &&
      timeDur &&
      challengeId &&
      language &&
      tags
    ) {
      dispatch(
        updateChallenge({
          challengeName,
          challengeDesc,
          difficultyLev,
          score,
          startDate,
          endDate,
          timeDur,
          challengeId,
          language,
          tags,
        })
      );
    } else {
      dispatch(redSetToast({ title: "Enter All Delatils", status: "error" }));
    }
  };

  return (
    <>
      <Toasts />
      <Flex
        as="main"
        justify="center"
        bg="gray.200"
        align="center"
        w="100%"
        h="100%"
      >
        <Flex
          w="97%"
          h="95%"
          borderRadius="20px"
          p={4}
          bg="white"
          px="20px"
          direction="column"
        >
          <Flex
            w="100%"
            h="100px"
            border="1px #e2e8f0 solid"
            p="10px"
            px="20px"
            borderRadius="15px"
            alignItems="center"
            justifyContent="left"
          >
            <FormControl>
              <FormLabel
                htmlFor="Challenge_Id"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Enter Challenge Id
              </FormLabel>
              <Input
                type="text"
                name="Challenge_Id"
                id="Challenge_Id"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="300px"
                rounded="md"
                placeholder="Challenge Id"
                onChange={(e) => setChallengeId(e.target.value)}
                value={challengeId}
              />

              <Button
                minW="170px"
                ml="30px"
                mb="10px"
                colorScheme="green"
                variant="solid"
                _hover={{ bg: "green.800" }}
                _active={{ bg: "green.600" }}
                isLoading={challengeDetailsLoading}
                onClick={() => {
                  if (challengeId) {
                    dispatch(getChallenge(challengeId));
                  } else {
                    dispatch(
                      redSetToast({
                        title: "Provide a Challenge Id",
                        status: "error",
                      })
                    );
                  }
                }}
              >
                Submit Challenge Id
              </Button>

              <Button
                minW="140px"
                ml="30px"
                mb="10px"
                colorScheme="red"
                variant="solid"
                _hover={{ bg: "red.600" }}
                _active={{ bg: "red.600" }}
                isDisabled={challengeId && challengeDetails ? false : true}
                onClick={() => {
                  if (challengeDetails?.challengeId) {
                    dispatch(deleteChallenge(challengeDetails.challengeId));
                  } else {
                    dispatch(
                      redSetToast({
                        title: "Challenge Details not founds",
                        status: "error",
                      })
                    );
                  }
                }}
              >
                Delete Challenge
              </Button>

              <Button
                minW="170px"
                ml="30px"
                mb="10px"
                colorScheme="yellow"
                color="white"
                variant="solid"
                _hover={{ bg: "yellow.500" }}
                _active={{ bg: "yellow.500" }}
                isDisabled={
                  (challengeId && challengeDetails) || updateChallenge
                    ? false
                    : true
                }
                onClick={handleUpdateChallenge}
              >
                Update Challenge
              </Button>
            </FormControl>
          </Flex>

          <Stack
            width="100%"
            bg="white"
            _dark={{
              bg: "#141517",
            }}
            spacing={6}
            p={4}
          >
            <SimpleGrid columns={6} spacing={6}>
              {/* Challenge Name */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Challenge_Name"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Challenge Name
                </FormLabel>
                <Input
                  type="text"
                  name="Challenge_Name"
                  id="Challenge_Name"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setChallengeName(e.target.value)}
                  value={challengeName}
                />
              </FormControl>

              {/* Challenge Description */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Challenge_Description"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Challenge Description
                </FormLabel>
                <Input
                  type="text"
                  name="Challenge_Description"
                  id="Challenge_Description"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setChallengeDesc(e.target.value)}
                  value={challengeDesc}
                />
              </FormControl>

              {/* Difficulty Level */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Difficulty_Level"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Difficulty Level
                </FormLabel>
                <Select
                  id="Difficulty_Level"
                  name="Difficulty_Level"
                  placeholder="Select option"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setDifficultyLev(e.target.value)}
                  value={difficultyLev}
                >
                  <option value="easy">Easy</option>
                  <option value="medium">Medium</option>
                  <option value="hard">Hard</option>
                </Select>
              </FormControl>

              {/* Score */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Score"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Score
                </FormLabel>
                <Input
                  type="text"
                  name="Score"
                  id="Score"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setScore(e.target.value)}
                  value={score}
                />
              </FormControl>

              {/* Start Date */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Start_Date"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Start Date
                </FormLabel>
                <Input
                  type="date"
                  name="Start_Date"
                  id="Start_Date"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                />
              </FormControl>

              {/* End Date */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="End_Date"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  End Date
                </FormLabel>
                <Input
                  type="date"
                  name="End_Date"
                  id="End_Date"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                />
              </FormControl>

              {/* Time Duration */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Time_Duration"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Time Duration{" "}
                </FormLabel>
                <Input
                  type="text"
                  name="Time_Duration"
                  id="Time_Duration"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setTimeDur(e.target.value)}
                  value={timeDur}
                />
              </FormControl>

              {/* Language */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Language"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Language
                </FormLabel>
                <Select
                  id="Language"
                  name="Difficulty_Level"
                  placeholder="Select option"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setLanguage(e.target.value)}
                  value={language}
                >
                  <option value="javascript">Javascript</option>
                  <option value="python">Python</option>
                  <option value="java">Java</option>
                </Select>
              </FormControl>

              {/* Tags */}
              <FormControl as={GridItem} colSpan={[3]}>
                <FormLabel
                  htmlFor="Tags"
                  fontSize="lg"
                  fontWeight="lg"
                  color="gray.700"
                  _dark={{
                    color: "gray.50",
                  }}
                >
                  Tags
                </FormLabel>
                <Input
                  type="text"
                  name="Tags"
                  id="Tags"
                  mt={1}
                  focusBorderColor="brand.400"
                  shadow="sm"
                  size="sm"
                  w="full"
                  rounded="md"
                  onChange={(e) => setTags(e.target.value)}
                  value={tags}
                />
              </FormControl>
            </SimpleGrid>
          </Stack>
        </Flex>
      </Flex>
    </>
  );
};

export default Deletetask;
